import styles from './inputField.module.scss';

const InputField = (props) => {
    return (
        <div
            className={`${styles.inputFieldContainer} ${props.customClass || ''}`}
            style={props.customStyle}
        >
            <p>
                {props.required ? '*' : null}
                <b>{props.label}</b>
            </p>
            <div className={`${styles.inputField} ${props.error ? styles.error : ''}`}>
                {props.path ? (
                    <img
                        src={require(`../../Assets/Images/Icons/Other/${props.path}`)}
                        alt={props.label}
                    />
                ) : null}
                <input
                    autoComplete='off'
                    disabled={props.disabled}
                    placeholder={props.placeholder}
                    onChange={props.onChange}
                    value={props.value}
                    maxLength={props.maxLength}
                    type={props.type === 'password' ? 'password' : undefined}
                />
            </div>
        </div>
    );
};

export default InputField;
